export default __webpack_public_path__ + "static/media/gummies@2x.fa281b7e.png";